import { observer } from "mobx-react-lite"
import { useEffect } from "react";
import { ReactComponent as DownArrow } from "../../images/icons/downArrow.svg";

const MenuElement = ({ name, Icon, link, bordered, children }) => {

    // useEffect(() => {
    //     console.log(window.location.pathname)
    // }, []);

    return (
        <>
            <a href={link} className={"/"+window.location.pathname.split("/")[1] == link || (link == "/calc" && window.location.pathname == "/890") ? "active":""+ bordered==true?" bordered":""}>
                <div className="title">
                    {/* <img src={icon} alt={name} /> */}
                    <Icon/>
                    <div className="name">{name}</div>
                </div>
                {children&&<DownArrow/>}
            </a>
            {children&& "/"+window.location.pathname.split("/")[1] == link && <ul>
                {children}
            </ul>}
        </>
    )
}

export default observer(MenuElement);